import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
// @ts-nocheck
import InputMask from "react-input-mask";
import { Input } from "ui";

import { DriverFormAtomProps } from "../DriverDetailsForm.types";

const PhoneField = ({ control }: DriverFormAtomProps) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name="phoneNumber"
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <InputMask
          mask="+999 99 99999999"
          value={value}
          onChange={onChange}
          alwaysShowMask={false}
          maskChar=""
        >
          {(inputProps) => (
            <Input
              {...inputProps}
              type="tel"
              label={t("Phone number")}
              errorMessage={error?.message}
              data-testid="driver--phoneNumber"
            />
          )}
        </InputMask>
      )}
    />
  );
};

export default PhoneField;
